import React from "react";
import "./switch.css";
const SwitchField = ({
	field,
	value,
	onChange
}) => {
	const handleChange = event => {
		onChange(field.name, event.target.checked);
	};

	return (
		<label
			className="form-generic__switch-field"
			htmlFor={field.id || field.name}
		>
			<span className="form-generic__switch-label">
				{field.label}
			</span>

			<input
				id={field.id || field.name}
				type="checkbox"
				name={field.name}
				checked={Boolean(value)}
				onChange={handleChange}
				disabled={field.disabled}
			/>

			<span className="form-generic__switch-control" />
		</label>
	);
};

export default SwitchField;